import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { initialize } from '@scalprum/core';
import { ScalprumContext } from './scalprum-context';
import { PluginStoreProvider } from '@openshift/dynamic-plugin-sdk';
function isInstanceProps(props) {
    return 'scalprum' in props;
}
function baseTransformPluginManifest(manifest) {
    return __assign(__assign({}, manifest), { loadScripts: manifest.loadScripts.map(function (script) { return "".concat(manifest.baseURL).concat(script); }) });
}
export function ScalprumProvider(props) {
    var state = useMemo(function () {
        var _a;
        if (isInstanceProps(props)) {
            return props.scalprum;
        }
        var config = props.config, api = props.api, pluginSDKOptions = props.pluginSDKOptions;
        var _b = (pluginSDKOptions === null || pluginSDKOptions === void 0 ? void 0 : pluginSDKOptions.pluginLoaderOptions) || {}, postProcessManifest = _b.postProcessManifest, transformPluginManifest = _b.transformPluginManifest;
        // SDK v4 and v5 compatibility layer
        var internalTransformPluginManifest = (_a = (postProcessManifest || transformPluginManifest)) !== null && _a !== void 0 ? _a : baseTransformPluginManifest;
        if (postProcessManifest) {
            console.error("[Scalprum] Deprecation warning!\n  Please use pluginSDKOptions.pluginLoaderOptions.transformPluginManifest instead of pluginSDKOptions.pluginLoaderOptions.postProcessManifest.\n  The postProcessManifest option will be removed in the next major release.");
        }
        return initialize(__assign(__assign({ appsConfig: config, api: api }, pluginSDKOptions), { pluginLoaderOptions: __assign(__assign({}, pluginSDKOptions === null || pluginSDKOptions === void 0 ? void 0 : pluginSDKOptions.pluginLoaderOptions), { transformPluginManifest: internalTransformPluginManifest }) }));
    }, []);
    return (React.createElement(ScalprumContext.Provider, { value: {
            config: state.appsConfig,
            api: state.api,
            initialized: true,
            pluginStore: state.pluginStore,
        } },
        React.createElement(PluginStoreProvider, { store: state.pluginStore }, props.children)));
}
//# sourceMappingURL=scalprum-provider.js.map